/* Flutes theme JS */
(function(){
  'use strict';
  var rmq = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* age gate (once per session) */
  var gate = document.getElementById('gate');
  if (gate) {
    var seen = false;
    try { seen = sessionStorage.getItem('flutesGate') === '1'; } catch(e){}
    if (seen) gate.classList.add('off');
    var yes = document.getElementById('gate-yes');
    if (yes) yes.addEventListener('click', function(){
      gate.classList.add('off');
      try { sessionStorage.setItem('flutesGate','1'); } catch(e){}
    });
  }

  /* sticky buy bar */
  var bar = document.getElementById('buybar');
  window.addEventListener('scroll', function(){
    if (bar) bar.classList.toggle('on', window.scrollY > 480);
  }, {passive:true});

  /* reveals + choreographed sections */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:.18});
    document.querySelectorAll('.reveal,.obs,footer').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal,.obs,footer').forEach(function(el){ el.classList.add('in'); });
  }

  /* how-to photo player */
  var htSteps = Array.prototype.slice.call(document.querySelectorAll('.ht-step'));
  var htFrames = Array.prototype.slice.call(document.querySelectorAll('.ht-f'));
  var htI = 0, htTimer = null;
  function htGo(i){
    htI = ((i % htFrames.length) + htFrames.length) % htFrames.length;
    htSteps.forEach(function(s,j){ s.classList.toggle('act', j===htI); });
    htFrames.forEach(function(f,j){ f.classList.toggle('act', j===htI); });
    var hc = document.querySelector('.ht-count');
    if (hc) hc.textContent = String(htI+1).padStart(2,'0') + ' / ' + String(htFrames.length).padStart(2,'0');
  }
  function htStart(){ if (!htTimer && htFrames.length) htTimer = setInterval(function(){ htGo(htI+1); }, 3400); }
  function htStop(){ if (htTimer){ clearInterval(htTimer); htTimer = null; } }
  htSteps.forEach(function(s){ s.addEventListener('click', function(){ htGo(+s.dataset.i); htStop(); htStart(); }); });
  var howEl = document.getElementById('howplayer');
  if (howEl) new IntersectionObserver(function(e){ e[0].isIntersecting ? htStart() : htStop(); }, {threshold:.25}).observe(howEl);

  /* every marked video plays when its section is on screen, pauses when it leaves */
  document.querySelectorAll('video[data-inview]').forEach(function(v){
    v.muted = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(e){
        e[0].isIntersecting ? v.play().catch(function(){}) : v.pause();
      }, {threshold:.3}).observe(v);
    } else { v.play().catch(function(){}); }
  });

  /* stat counters */
  var statsEl = document.querySelector('.stats');
  if (statsEl) new IntersectionObserver(function(e,o){
    if (!e[0].isIntersecting) return;
    o.disconnect();
    statsEl.querySelectorAll('.cnt-n').forEach(function(el){
      var to = parseFloat(el.dataset.to), dec = parseInt(el.dataset.dec||'0',10), t0 = performance.now();
      (function tick(t){
        var p = Math.min((t-t0)/950, 1), k = 1 - Math.pow(1-p, 3);
        el.textContent = (to*k).toFixed(dec);
        if (p < 1) requestAnimationFrame(tick); else el.textContent = to.toFixed(dec).replace(/\.0$/,'');
      })(t0);
    });
  }, {threshold:.4}).observe(statsEl);

  /* email-capture popup: discount code reveal */
  var promo = document.getElementById('promo');
  var isHome = document.body.classList.contains('template-index');
  var justSignedUp = window.location.search.indexOf('customer_posted=true') !== -1;
  var promoShown = false;
  function closePromo(){ if (promo) promo.classList.remove('show'); }
  function openPromo(){
    if (!promo || promoShown) return;
    promoShown = true;
    try { sessionStorage.setItem('flutesPromoSeen','1'); } catch(e){}
    promo.classList.add('show');
    var pe = document.getElementById('promo-email');
    if (pe) pe.focus();
  }
  function tryPromo(){
    if (!promo || promoShown || !isHome) return;
    var g = document.getElementById('gate');
    if (window.scrollY > 600 && (!g || g.classList.contains('off'))) setTimeout(openPromo, 300);
  }
  if (promo) {
    var alreadySeen = false;
    try { alreadySeen = sessionStorage.getItem('flutesPromoSeen') === '1'; } catch(e){}
    document.querySelectorAll('[data-promo-close]').forEach(function(b){ b.addEventListener('click', closePromo); });
    promo.addEventListener('click', function(e){ if (e.target === promo) closePromo(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closePromo(); });

    if (justSignedUp) {
      /* signup succeeded: clear the age gate out of the way and show the code, on any page */
      var gate = document.getElementById('gate');
      if (gate) {
        gate.classList.add('off');
        try { sessionStorage.setItem('flutesGate','1'); } catch(e){}
      }
      promo.classList.add('is-success');
      openPromo();
    } else if (isHome && !alreadySeen) {
      window.addEventListener('scroll', tryPromo, {passive:true});
      var gy = document.getElementById('gate-yes');
      if (gy) gy.addEventListener('click', function(){ setTimeout(tryPromo, 400); });
    }
  }

  /* click the code to copy it */
  document.querySelectorAll('[data-copy-code]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var code = btn.dataset.code || btn.textContent.trim();
      var note = document.querySelector('[data-copy-note]');
      function done(){
        btn.classList.add('copied');
        if (note) note.textContent = 'Copied to clipboard';
        window.setTimeout(function(){
          btn.classList.remove('copied');
          if (note) note.textContent = 'Click to copy \u00b7 enter it at checkout';
        }, 2200);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function(){});
      } else {
        var ta = document.createElement('textarea');
        ta.value = code; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); done(); } catch(e){}
        document.body.removeChild(ta);
      }
    });
  });

  /* scroll progress + hero parallax */
  var prog = document.getElementById('scrollprog');
  var heroVid = document.querySelector('.hero > video');
  var sTick = false;
  window.addEventListener('scroll', function(){
    if (sTick) return; sTick = true;
    requestAnimationFrame(function(){
      var y = window.scrollY, d = document.documentElement.scrollHeight - window.innerHeight;
      if (prog) prog.style.width = (d > 0 ? (y/d*100) : 0) + '%';
      if (heroVid && !rmq && y < window.innerHeight*1.3) heroVid.style.transform = 'translateY(' + (y*0.22) + 'px)';
      sTick = false;
    });
  }, {passive:true});

  /* product variant selector */
  var vform = document.querySelector('[data-product-form]');
  if (vform) {
    var idInput = vform.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var btn = vform.querySelector('[data-atc]');
    vform.querySelectorAll('input[name="variant-pick"]').forEach(function(r){
      r.addEventListener('change', function(){
        idInput.value = r.dataset.variantId;
        if (priceEl && r.dataset.price) priceEl.textContent = r.dataset.price;
        if (btn) {
          var ok = r.dataset.available === 'true';
          btn.disabled = !ok;
          btn.textContent = ok ? btn.dataset.labelAdd : 'Sold out';
        }
      });
    });
  }

  /* product gallery thumbs */
  document.querySelectorAll('[data-thumb]').forEach(function(t){
    t.addEventListener('click', function(){
      var main = document.querySelector('[data-main-image]');
      if (main) main.src = t.dataset.full;
    });
  });

  /* keep newsletter signups in place: return to the form, not page top */
  if (window.location.search.indexOf('customer_posted=true') !== -1) {
    var join = document.getElementById('join');
    if (join) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      requestAnimationFrame(function(){ join.scrollIntoView({block:'center'}); });
    }
  }

  /* keep cart totals current when quantity changes */
  var cartQtyInputs = document.querySelectorAll('input[name="updates[]"]');
  if (cartQtyInputs.length) {
    var cartForm = cartQtyInputs[0].form;
    var cartUpdate = cartForm && cartForm.querySelector('button[type="submit"]:not([name="checkout"])');
    cartQtyInputs.forEach(function(input){
      input.addEventListener('change', function(){
        if (cartForm.requestSubmit && cartUpdate) cartForm.requestSubmit(cartUpdate);
        else cartForm.submit();
      });
    });
  }

})();
